<template>
  <div class="flex flex-col gap-6">
    <div class="flex flex-col gap-2">
      <div>
        <h3 class="capitalize-first text-base font-semibold">
          {{ $t('global.who_amount_received') }}
        </h3>
      </div>
      <div class="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        <div>
          <SelectUser
            v-model="localPayment.recipient_id"
            :errors="errors?.recipient_id"
            :label="$t('attributes.received_by')"
            name="received_by"
            edition-mode
            required
          />
        </div>
        <div class="col-span-2 col-start-1">
          <BaseShowEditTextArea
            v-model="localPayment.comment"
            class="col-span-2"
            :label="$t('attributes.remarks')"
            :placeholder="$t('hint.remarks_example')"
            :errors="errors.remarks"
            :edition-mode="true"
            name="comment"
          />
        </div>
      </div>
    </div>
    <slot name="other-informations" />
  </div>
</template>

<script>
import SelectUser from '@c/InitialStateFormComponent/SelectUser.vue'
import BaseShowEditTextArea from '@c/addf-package/components/BaseShowEditInput/BaseShowEditTextArea.vue'

export default {
  name: 'SelectOtherInformations',
  components: {
    BaseShowEditTextArea,
    SelectUser
  },
  props: {
    payment: {
      type: Object,
      required: true
    },
    errors: {
      type: Array,
      required: true
    },
  },
  emits: ['update:payment'],
  computed: {
    localPayment: {
      get() {
        return this.payment
      },
      set(value) {
        this.$emit('update:payment', value)
      }
    }
  }
}
</script>
